import { render, staticRenderFns } from "./ecatalog.vue?vue&type=template&id=38f440c8&"
import script from "./ecatalog.vue?vue&type=script&lang=js&"
export * from "./ecatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports